<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img src="../../assets/images/logo/logo-green.png">
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
        style="background-color:#f0f9f5 ;"
      >
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img
            fluid
            style="width: 70%;"
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="row auth-bg px-1 p-2 pt-3"
        style="border-left: solid 1px #182c25"
      >
        <div
          class="col-md-12 pr-0 languages-mobile"
          align="end"
        >
          <b-dropdown
            id="dropdown-grouped"
            text="Dark"
            variant="outline-dark"
            class="dropdown-language no-border-button"
            right
          >
            <template #button-content>
              <b-img
                :src="currentLocale.img"
                height="14px"
                width="22px"
                :alt="currentLocale.locale"
              />
              <span class="ml-50 text-body">{{ $t(currentLocale.name) }}</span>
            </template>
            <b-dropdown-item
              v-for="localeObj in locales"
              :key="localeObj.locale"
              @click="$i18n.locale = localeObj.locale"
            >
              <b-img
                :src="localeObj.img"
                height="14px"
                width="22px"
                :alt="localeObj.locale"
              />
              <span class="ml-50">{{ $t(localeObj.name) }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto mt-2"
        >
          <h4 class="row justify-content-between">
            <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-2 col-md-12"
            >
              {{ $t("forgot_password") }}
            </b-card-title>
          </h4>

          <b-card-text class="mb-2">
            {{ $t("please_enter_your_email_to_reset_your_password") }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="forgotPasswordValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                :label="$t('email')"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model.trim="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                    :disabled="disableInputs"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                {{ $t("continue") }}
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>{{ $t("new_on_our_platform") }} </span>
            <b-link :to="{ name: 'register' }">
              <span>&nbsp; {{ $t("create_an_account") }} </span>
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      disableInputs: false,
      userEmail: '',
      password: '',
      sideImg: require('@/assets/images/pages/login-v5.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      language: '',
      locales: [
        {
          locale: 'en',
          img: '/images/flags/en.png',
          name: 'English',
        },

        {
          locale: 'de',
          img: '/images/flags/german.png',
          name: 'Deutch',
        },
      ],
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v5.png')
        return this.sideImg
      }
      return this.sideImg
    },
    currentLocale() {
      let obj = null
      if (this.$i18n.locale) {
        if (this.$i18n.locale == 'en') {
          obj = {
            locale: 'en',
            img: '/images/flags/en.png',
            name: 'english',
          }
        } else {
          obj = {
            locale: 'de',
            img: '/images/flags/german.png',
            name: 'german',
          }
        }
      } else {
        obj = {
          locale: 'en',
          img: '/images/flags/en.png',
          name: 'english',
        }
      }
      this.$store.commit('app/UPDATE_LANGUAGE', obj.locale)
      return obj
    },
  },
  methods: {
    toggleLanguage(language) {
      this.$i18n.locale = language
      this.language = language
      this.$store.commit('app/UPDATE_LANGUAGE', language)
    },
    validationForm() {
      this.$refs.forgotPasswordValidation.validate().then(success => {
        if (success) {
          this.disableInputs = true
          this.$http
            .post('/forgot-password', {
              email: this.userEmail,
              language: this.currentLocale.locale,
            })
            .then(res => {
              if (res.data.status === 200) {
                this.$store.commit('auth/UPDATE_RESET_EMAIL', this.userEmail)
                this.$router.push('/reset-password')
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t(
                      'please_check_your_email',
                    ),
                    icon: 'SuccessIcon',
                    variant: 'success',
                  },
                })
              } else {
                this.disableInputs = false
                this.$store.commit('auth/UPDATE_RESET_EMAIL', null)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('email_address_does_not_exist_in_platform!'),
                    icon: 'ErrorIcon',
                    variant: 'error',
                  },
                })
              }
            })
            .catch(() => {
              this.disableInputs = false
              this.$store.commit('auth/UPDATE_RESET_EMAIL', null)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t(
                    'failed_to_authenticate_with_provided_credentials!',
                  ),
                  icon: 'ErrorIcon',
                  variant: 'error',
                },
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
